import { render } from "./team-logo-vs.vue?vue&type=template&id=443f1e0a&scoped=true"
import script from "./team-logo-vs.vue?vue&type=script&lang=js"
export * from "./team-logo-vs.vue?vue&type=script&lang=js"

import "./team-logo-vs.vue?vue&type=style&index=0&id=443f1e0a&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443f1e0a"]])

export default __exports__